import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgConfirmed = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 17,
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M12.143 6.565a.666.666 0 0 1-.01.943l-2.95 2.897a2.656 2.656 0 0 1-3.718.014L4.2 9.175a.667.667 0 1 1 .935-.951l1.262 1.24c.517.5 1.334.498 1.854-.011l2.95-2.896a.666.666 0 0 1 .943.008ZM16 8.5c0 4.411-3.589 8-8 8s-8-3.589-8-8 3.589-8 8-8 8 3.589 8 8Zm-1.333 0A6.674 6.674 0 0 0 8 1.833 6.674 6.674 0 0 0 1.333 8.5 6.674 6.674 0 0 0 8 15.167 6.674 6.674 0 0 0 14.667 8.5Z"
	})
});
export default SvgConfirmed;
